export const ENABLE_DELETE_PASSENGERS = 'ENABLE_DELETE_PASSENGERS'

export default () => ({
  type: ENABLE_DELETE_PASSENGERS,
})
